import React, {useState,useEffect} from "react";
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

import firebase from './database/firebase';
import { StyleSheet, Text, View, Button, TextInput, Dimensions,ActivityIndicator } from "react-native";
import { RadioButton } from 'react-native-paper';
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const user_id = urlParams.get('uid');


const Translate = (props) => {

    const [isSelected, setSelection] = useState("yes");
    const [post, setPost] = useState(props.navigation.state.params.originalpost);
    const [translation, setTranslation] = useState("");
    const [destination, setDestination] = useState('Tfinal');
    const [lang, setLang] = useState('');
    const [count, setCount] = useState(0);
    const [loading,setLoading]=useState(false);

    if(loading ===true){
      return(
        <View style={styles.container}>
			<Text style={styles.label2}>Translating the post.....</Text> 
	  <View style={styles.preloader}>
		

		<CountdownCircleTimer
			isPlaying
			duration={7}
			colors={['#004777', '#F7B801', '#A30000', '#A30000']}
			colorsTime={[7, 5, 2, 0]}
		>
			{({ remainingTime }) => remainingTime}
		</CountdownCircleTimer>
		
	  </View>
	  </View>
      )
      } 
      else{
      return(
        <div>   
			<View style={styles.container}>
				  
                <Text style={styles.label}>On the next page, we will show you the post that you have just written and its machine translation in English. These two parts can be shown to readers who do not understand {props.navigation.state.params.language}. </Text>
                <Text style={styles.label2}>You will have access to edit this translation as you see fit.</Text>

				<View style={styles.buttonContainer}>

                <Button 
                    color='#341ada'
                    title="Back"
                    style={StyleSheet.buttonStyle}
                    onPress={() => { props.navigation.navigate('Main', {detail: props.navigation.state.params.originalpost, language: props.navigation.state.params.language,uid:user_id}); }}> 
                </Button>
                
                <Button 
                    color='#341ada'
                    title="Next"
                    style={StyleSheet.buttonStyle}
                    onPress={() => {
                      setLoading(true);
                      setTimeout(() => {
							
                        props.navigation.navigate('Translate', {originalpost: props.navigation.state.params.originalpost,translated:"", language: props.navigation.state.params.language,uid:user_id,firsttopic:props.navigation.state.params.firsttopic});
                        setLoading(false);
                      }, 5000); 
                }
                  }> 
                </Button>
				

				</View>
                
			</View>
        </div>
      )
    }
}
const styles = StyleSheet.create({
	container: {
		padding: 20,
		flex: 1,
		display: "flex",
		marginRight: Dimensions.get('window').width/8,
    marginLeft: Dimensions.get('window').width/8,
		textAlign: 'center',
    alignItems: 'center',
		flexDirection: "column",
		justifyContent: "center",
    marginTop:Dimensions.get('window').height/4.5,
	},
  
	buttonContainer:{
    marginTop:Dimensions.get('window').height/6,
    width: '40%',
		alignSelf: 'center',
		marginVertical: 25,
        marginHorizontal: 30,
        flex:1,
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center'
	},

	text: {
		fontWeight: "bold",
		fontSize: 20
	},
	buttonStyle: {
		alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 12,
	paddingHorizontal: 60,
	borderRadius: 0,
	elevation: 13,
	backgroundColor:"#341ada"
	},
    
	listContainer: {
        flexDirection: "column",
		paddingTop: 12
	},
	listItem: {
		fontSize: 20
	},
    checkboxContainer: {
        flexDirection: "row",
        justifyContent: "center",
        marginBottom: 2,
      },
      checkbox: {
        alignSelf: "center",
      },
      label: {
        //margin: 8,
       
        fontSize: 25,
      },
      label2: {
        //margin: 8,
        fontWeight: "bold",
        fontSize: 25,
      },
	textAreaContainer: {
		
		paddingTop: 12,
    paddingRight:Dimensions.get('window').width/15,
		paddingLeft: Dimensions.get('window').width/15,
		paddingBottom: 1,

	  },
	  textArea1: {
    backgroundColor:'#D3D3D3',
		height: 260,
		fontSize: 19,
		borderColor: '#000000',
		borderWidth: 1,
		justifyContent: "flex-start"
	  },
    textArea2: {
      height: 260,
      fontSize: 19,
      borderColor: '#341ada',
      borderWidth: 3,
      justifyContent: "flex-start"
      },
      preloader:{
        flex: 1,
        display: "flex",
        marginTop: 20,
        marginBottom:20,
        alignSelf: 'center',
        textAlign: 'center',
        flexDirection: "column",
        justifyContent: "center",
      },
      label2: {
        //margin: 8,
        fontWeight: "bold",
        fontSize: 25,
      },
	  radioContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
	},radioContainer2: {
	//	padding: 1,
		//marginTop: 8,
		textAlign: 'center',
        flexDirection: "column",
	},
})
export default Translate